import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || "us-east-1",
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_USER_POOL_DOMAIN,
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn:
        window.location.hostname === "localhost"
          ? "http://localhost:3000/oauth2/login-redirect"
          : `https://${window.location.hostname}/oauth2/login-redirect`,
      redirectSignOut:
        window.location.hostname === "localhost"
          ? "http://localhost:3000/"
          : `https://${window.location.hostname}`,
      responseType: "code",
    },
  },
});

export default Amplify;
